export enum ToastType {
  INFO,
  WARN,
  ERROR,
  SUCCESS
}



// WEBPACK FOOTER //
// /dist/src/app/notify/toast/toast-type.enum.ts